<template>
  <span class="tag__label">{{ label }}</span>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.tag {
  &__label {
    background-color: $color-secondary;
    border-radius: 100px;
    color: #fff;
    display: inline-block;
    height: 26px;
    padding: 0 10px;
    position: relative;
    margin: 1.5px 2px;
    text-decoration: none;
    transition: background-color 0.3s;
    user-select: none;
    cursor: pointer;
    font-weight: normal;
    &:hover {
      background-color: $color-secondary--dark;
    }
  }
}
</style>
